/**
 * @file
 * After Ajax Call.
 *
 */
(function ($, Drupal) {
  let toyboxSearchPropsToPlausibleExecuted;

  Drupal.behaviors.toybox_search_page_plausible_tracking = {
    // eslint-disable-next-line no-unused-vars
    attach: function (context, settings) {
      if (typeof plausible === "undefined") {
        console.error("Plausible is undefined.");
        return;
      }

      const searchProps = drupalSettings.bupl_search;
      // Only execute this code once.
      // To prevent sending the same data to plausible twice.
      // A search text needs to be provided, otherwise we don't send anything.
      if (
        !toyboxSearchPropsToPlausibleExecuted &&
        searchProps &&
        searchProps.search_text
      ) {
        toyboxSearchPropsToPlausibleExecuted = true;
        $.fn.sendSearchPropsToPlausible(drupalSettings.bupl_search);
      }
    },
  };

  $.fn.sendSearchPropsToPlausible = function (searchProps) {
    const {
      view_id,
      search_text,
      has_no_results,
      job_types,
      kommuner,
      year,
      hours_to,
      hours_from,
    } = searchProps;

    let searchPageName = "";
    let props = {
      søgetekst: search_text ? search_text : "<blank>",
    };
    const hoursTo = hours_to ? hours_to : "alle";
    const hoursFrom = hours_from ? hours_from : "alle";

    switch (view_id) {
      case "search":
        searchPageName = "Find Indhold";
        break;

      case "events":
        searchPageName = "Arrangementer";
        break;

      case "find_jobads":
        searchPageName = "Stillingsannoncer";
        props.stillingstype = job_types ? job_types : "Alle";
        props.kommune = kommuner ? kommuner : "Alle";
        props.timeantal = `fra: ${hoursTo} - til: ${hoursFrom}`;
        break;

      case "bu_archives_search":
        searchPageName = "Børn & Unge-arkiv";
        props.år = year ? year : "Alle";
        break;
    }

    let id = `${searchPageName} Søgning`;
    // eslint-disable-next-line no-undef
    plausible(id, { props: props });

    if (has_no_results) {
      id = `${searchPageName} Søgning - Ingen Resultater`;
      // eslint-disable-next-line no-undef
      plausible(id, { props: props });
    }
  };

  Drupal.AjaxCommands.prototype.afterViewsAjaxCall = function (ajax, response) {
    $.fn.sendSearchPropsToPlausible(response.search_props);
  };
})(jQuery, Drupal);
